import React from 'react';
import ReactDOM from 'react-dom';
ICMIB.renderResponse = function(el, props) {
  ReactDOM.render(React.createElement(ICMIB.SurveyResponse, props), el);
};

import SurveyResponse from '../components/survey/response/SurveyResponse';
ICMIB.SurveyResponse = SurveyResponse;

import cookiePolicyNotice from '../utils/cookiePolicyNotice';
ICMIB.cookiePolicyNotice = cookiePolicyNotice;

// Explicitly include sessions js since we don't always put app.js on responses page
ICMIB.sessions = require('../icmib/sessions');
